import { render, staticRenderFns } from "./SingleImgFileUpload.vue?vue&type=template&id=49c4abb2&scoped=true"
import script from "./SingleImgFileUpload.vue?vue&type=script&lang=js"
export * from "./SingleImgFileUpload.vue?vue&type=script&lang=js"
import style0 from "./SingleImgFileUpload.vue?vue&type=style&index=0&id=49c4abb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c4abb2",
  null
  
)

export default component.exports